import "../styles/SchedulePage.css";
import useQuote from "../hooks/useQuote";
import LoadingSpinner from "./LoadingSpinner";
import ErrorMessage from "./ErrorMessage";
import QuoteDetails from "./QuoteDetails";

function SchedulePage({ uuid }) {
  const { quote, loading, error } = useQuote(uuid);

  if (loading) {
    return <LoadingSpinner message="Carregando dados da cotação..." />;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  return (
    <div className="schedule-container">
      <QuoteDetails quote={quote} />
    </div>
  );
}

export default SchedulePage;

